import React from 'react';
import { Formik, Form } from 'formik';

import { FormInput, SelectInput } from '../../../../../components/form';
import { Button } from '../../../../../components/common';


function PlanListFilters({ onFilterChange, defaultValues }: Props) {
    const initialValues = {
        name: defaultValues?.name || '',
        isDefault: defaultValues?.isDefault || '',
        active: defaultValues?.active || '',
    };

    const handleSubmit = (values: any) => {
        onFilterChange(values);
    };

    const handleReset = (resetForm: any) => {
        resetForm();
        onFilterChange({});
    };

    return (
        <div className="mb-6">
            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({ setFieldValue, resetForm, values }) => (
                    <Form>
                        <div className="flex flex-wrap gap-4 items-end">
                            <div className="flex-1 min-w-64">
                                <label htmlFor="input-name" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                    Plan Name
                                </label>
                                <FormInput
                                    name="name"
                                    id="input-name"
                                    placeholder="Search by plan name..."
                                    className="w-full"
                                />
                            </div>

                            <div className="min-w-48">
                                <label htmlFor="input-isDefault" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                    Plan Type
                                </label>
                                <SelectInput
                                    items={[
                                        { label: 'All Plans', value: '' },
                                        { label: 'Default Plans', value: 'true' },
                                        { label: 'Custom Plans', value: 'false' },
                                    ]}
                                    value={values.isDefault}
                                    onChange={(selected: any) => setFieldValue('isDefault', selected.value)}
                                />
                            </div>

                            <div className="min-w-48">
                                <label htmlFor="input-active" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                    Status
                                </label>
                                <SelectInput
                                    items={[
                                        { label: 'All Status', value: '' },
                                        { label: 'Active', value: 'true' },
                                        { label: 'Inactive', value: 'false' },
                                    ]}
                                    value={values.active}
                                    onChange={(selected: any) => setFieldValue('active', selected.value)}
                                />
                            </div>

                            <div className="flex gap-2">
                                <Button type="submit" className="py-2.5">
                                    Search
                                </Button>
                                <Button 
                                    type="button" 
                                    onClick={() => handleReset(resetForm)} 
                                    className="py-2.5 bg-gray-500 hover:bg-gray-600"
                                >
                                    Reset
                                </Button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
}


interface Props {
    onFilterChange: (filters: any) => void;
    defaultValues?: any;
}


export default PlanListFilters;